import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { FooterComponent } from '../footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { showLoadingMaskAction, setScreenWidthAction } from '../../ngrx/actions/global.actions';
import { selectScreenWidth, selectContainerType, AppBreakpoints } from '../../ngrx/app.state';
import { ScreenWidth } from '../../ngrx/models/screenWidth.model';
import { LoadingMaskComponent } from '../loading-mask/loading-mask.component';
import { StatefulComponent } from '../stateful/stateful.component';
import { inject } from '@vercel/analytics';
import { injectSpeedInsights } from '@vercel/speed-insights';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    styleUrls: ['./app.component.scss'],
    imports: [HeaderComponent, NgClass, RouterOutlet, FooterComponent, LoadingMaskComponent]
})
export class AppComponent extends StatefulComponent implements OnInit, AfterViewInit {
  containerType: 'normal' | 'fluid' = 'normal';
  screenWidth: ScreenWidth | undefined;

  constructor(
    private cd: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver) {
    super();
  }

  ngOnInit(): void {
    this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
    this.subscribeToContainerType();
    this.subscribeToScreenWidth();

    // example of how to subscribe to global screen width in other components
    this.subs.push(this.select(selectScreenWidth)
      .subscribe((screenWidth: ScreenWidth) => {
        this.screenWidth = screenWidth;
      })
    );
  }

  ngAfterViewInit() {
    inject();
    injectSpeedInsights();
  }

  private subscribeToContainerType() {
    this.subs.push(this.select(selectContainerType)
      .subscribe((containerType: 'normal' | 'fluid' | undefined) => {
        if (containerType) {
          this.containerType = containerType;
          this.cd.detectChanges();
        }
      })
    );
  }

  private subscribeToScreenWidth() {
    let breakpointsMap = new Map<AppBreakpoints, string>([
      [AppBreakpoints.xxl, "xxl"],
      [AppBreakpoints.xl, "xl"],
      [AppBreakpoints.lg, "lg"],
      [AppBreakpoints.md, "md"],
      [AppBreakpoints.sm, "sm"],
      [AppBreakpoints.xs, "xs"]
    ]);

    let breakpoints = Array.from(breakpointsMap.keys());

    // this updates both this.screenWidth for app.component locally,
    // and the global screenWidth attribute for other components
    this.subs.push(
      this.breakpointObserver.observe(
        breakpoints.map(m => this.generateBreakpointString(m)))
        .subscribe((state: BreakpointState) => {
          this.dispatch(
            setScreenWidthAction({
              screenWidth: breakpointsMap.get(breakpoints.find(m =>
                state.breakpoints[this.generateBreakpointString(m)]) ?? 0) as ScreenWidth
            })
          );
        })
    );
  }

  private generateBreakpointString(breakpoint: AppBreakpoints): string {
    return `(min-width: ${breakpoint}px)`;
  }

  isContainerNormal() {
    return this.containerType === 'normal';
  }
}
